module.exports = __webpack_public_path__ + "img/header-engagementRingsDainty@2x.ca0abe2.webp";